
import React, { useCallback, useEffect, useRef, useState } from "react";
import Button from '@material-ui/core/Button';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
  import {useDispatch, useSelector} from 'react-redux';
  import {
  getCGSPresignUrl,
  uploadRecordings
} from '../../../redux/actions';
  import { useAuthUser } from '../../utility/AppHooks';
// ---- Utility helpers ----
const bytesToSize = (bytes) => {
  if (bytes === 0) return "0 B";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

// ---- Core Component ----
function FileDropzone({
  accept = "*",
  multiple = true,
  maxSize = Infinity,
  uploadUrl, // optional — if present, the component exposes an Upload button
  headers = {},
  onFilesChange, // callback(filesMeta)
  fieldName = "files", // FormData key used for uploads
  passKey,
  encryptpassword,
  setgenFileName,
  setmp3uplBlob,
  setloading
}) {
   const user = useAuthUser();
   const dispatch = useDispatch();
  const [items, setItems] = useState([]); // { id, file, previewUrl?, error?, progress, uploaded }
  const [isDragging, setIsDragging] = useState(false);
  const inputRef = useRef(null);
  const idCounter = useRef(0);
    const uploadRecRes = useSelector(
      ({dashboard}) => dashboard.uploadRecRes,
    );
  const emitChange = useCallback(
    (list) => onFilesChange && onFilesChange(list.map(({ file, ...meta }) => ({ file, ...meta }))),
    [onFilesChange]
  );
  useEffect(()=>{
      if(uploadRecRes != '' && uploadRecRes === 'Success'){
        setItems([])
      }
    },[uploadRecRes])

  useEffect(() => {
    return () => {
      // cleanup previews on unmount
      items.forEach((it) => it.previewUrl && URL.revokeObjectURL(it.previewUrl));
    };
  }, [items]);

  const openFileDialog = () => inputRef.current?.click();

  const validateFile = (file) => {
    const errors = [];
    if (file.size > maxSize) errors.push(`File exceeds ${bytesToSize(maxSize)}.`);

    // Accept validation supports comma-separated MIME types and extensions (e.g. "image/*,.pdf")
    if (accept && accept !== "*") {
      const accepts = accept.split(",").map((s) => s.trim().toLowerCase());
      const ext = "." + file.name.split(".").pop().toLowerCase();
      const mime = (file.type || "").toLowerCase();
      const ok = accepts.some((rule) => {
        if (rule.endsWith("/*")) {
          // image/* -> compare major type
          return mime.startsWith(rule.slice(0, rule.length - 1));
        }
        if (rule.startsWith(".")) return rule === ext; // extension rule
        return rule === mime; // exact mime
      });
      if (!ok) errors.push("File type not allowed.");
    }

    return errors;
  };

  const addFiles = (fileList) => {
    const files = Array.from(fileList || []);
    const next = files.map((file) => {
      const id = ++idCounter.current;
      const errors = validateFile(file);
      const isImage = file.type.startsWith("image/");
      return {
        id,
        file,
        blob:new Blob([file], { type: file.type }),
        error: errors.length ? errors.join(" ") : undefined,
        previewUrl: isImage ? URL.createObjectURL(file) : undefined,
        progress: 0,
        uploaded: false,
      };
    });
    setItems((prev) => {
      const merged = multiple ? [...prev, ...next] : [...next];
      emitChange(merged);
      return merged;
    });
  };

  const onInputChange = (e) => {
    addFiles(e.target.files);
    e.target.value = ""; // allow re-adding same file
  };

  const onDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    if (e.dataTransfer?.files?.length) addFiles(e.dataTransfer.files);
  };

  const onDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isDragging) setIsDragging(true);
  };

  const onDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Only end drag when leaving the dropzone, not when entering a child
    if (e.currentTarget.contains(e.relatedTarget)) return;
    setIsDragging(false);
  };

  const removeItem = (id) => {
    setItems((prev) => {
      const next = prev.filter((it) => it.id !== id);
      const removed = prev.find((it) => it.id === id);
      if (removed?.previewUrl) URL.revokeObjectURL(removed.previewUrl);
      emitChange(next);
      return next;
    });
  };

  const clearAll = () => {
    setItems((prev) => {
      prev.forEach((it) => it.previewUrl && URL.revokeObjectURL(it.previewUrl));
      const next = [];
      emitChange(next);
      return next;
    });
  };

  const uploadAll = async () => {
    if (!uploadUrl) return;
    // Simple sequential uploads with progress per file
    for (const it of items) {
      if (it.error) continue;
      await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("POST", uploadUrl);
        Object.entries(headers).forEach(([k, v]) => xhr.setRequestHeader(k, v));
        xhr.upload.onprogress = (evt) => {
          if (evt.lengthComputable) {
            const pct = Math.round((evt.loaded / evt.total) * 100);
            setItems((prev) => prev.map((x) => (x.id === it.id ? { ...x, progress: pct } : x)));
          }
        };
        xhr.onload = () => {
          setItems((prev) => prev.map((x) => (x.id === it.id ? { ...x, uploaded: true, progress: 100 } : x)));
          resolve();
        };
        xhr.onerror = reject;
        const form = new FormData();
        form.append(fieldName, it.file);
        xhr.send(form);
      });
    }
  };

  // ---- Styles (no external CSS/NPM) ----
  const styles = {
    zone: {
      border: isDragging ? "2px solid #3b82f6" : "2px dashed #9ca3af",
      background: isDragging ? "#eff6ff" : "#f9fafb",
      borderRadius: 16,
      padding: 24,
      textAlign: "center",
      cursor: "pointer",
      transition: "all .15s ease-in-out",
      width:'61%'
    },
      disdoneButtonStyle:{
    background: '#8080809c',
    textTransform: 'capitalize',
    padding: '8px 12px',
  },
    helper: { fontSize: 14, color: "#6b7280", marginTop: 6 },
    list: { marginTop: 16, display: "flex", gap: 12 ,justifyContent:'center',marginBottom: 16},
    item: {
      display: "grid",
      gridTemplateColumns: "56px 1fr auto",
      alignItems: "center",
      gap: 12,
      border: "1px solid #e5e7eb",
      borderRadius: 12,
      padding: 10,
      background: "#fff",
      width:'61%'
    },
    thumb: {
      width: 56,
      height: 56,
      borderRadius: 8,
      objectFit: "cover",
      background: "#f3f4f6",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: 12,
      color: "#6b7280",
    },
    removeBtn: {
      border: "none",
      background: "transparent",
      cursor: "pointer",
      padding: 6,
      borderRadius: 8,
    },
    chip: {
      fontSize: 12,
      padding: "2px 8px",
      borderRadius: 999,
      background: "#f3f4f6",
      marginLeft: 8,
    },
    error: { color: "#b91c1c", fontSize: 12 },
    actions: { display: "flex", gap: 8, marginTop: 12, justifyContent: "center" ,paddingBottom:'14px',paddingRight:'14px'},
    btn: {
      padding: "8px 12px",
      borderRadius: 10,
      border: "1px solid #d1d5db",
      background: "#fff",
      cursor: "pointer",
    },
    btnPrimary: {
      padding: "8px 12px",
      borderRadius: 10,
      border: "1px solid #2563eb",
      background: "#2563eb",
      color: "white",
      cursor: "pointer",
    },
    progressBarWrap: {
      height: 6,
      background: "#f3f4f6",
      borderRadius: 999,
      overflow: "hidden",
      marginTop: 6,
    },
      doneButtonStyle: {
    background: '#8B00F7',
    color: 'white',
    textTransform: 'capitalize',
    padding: '8px 12px',
    '&:hover': {
      background: '#8B00F7',
      color: 'white',
    }
  },
    progressBar: (pct) => ({
      width: `${pct}%`,
      height: "100%",
      background: "#3b82f6",
      transition: "width .2s",
    }),
  };
  console.log(items,'items')
  function saveAudio(){
if(items && items?.length > 0){
        let blob=items[0]?.blob;
        setmp3uplBlob(blob)
                let passCode=passKey+'_'+Date.now()
      let newCode= encryptpassword({data: passCode});
      //gen file name
          setloading(true)
      let fileName='doceRx_'+user.doctorCode+'_'+Date.now();
      setgenFileName(fileName);
          dispatch(getCGSPresignUrl({accessKey:newCode,fileName:fileName,doctorCode:Number(user.doctorCode)}));
      }
    }
  return (
    <div style ={{height: '48vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'}}>
        <div style={{display:'flex',justifyContent:'center'}}>
             <div
        role="button"
        tabIndex={0}
        aria-label="File uploader dropzone"
        onClick={openFileDialog}
        onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && openFileDialog()}
        onDrop={onDrop}
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        style={styles.zone}
      >
        <strong>Drag & drop audio file here</strong>
        <div style={styles.helper}>or click to browse file (file formats MP3)</div>
        <input
          ref={inputRef}
          type="file"
          style={{ display: "none" }}
          accept={accept}
          multiple={multiple}
          onChange={onInputChange}
        />
      </div>
            </div>
     

      <div style={styles.list}>
        {items.map((it) => (
          <div key={it.id} style={styles.item}>
            {it.previewUrl ? (
              <img src={it.previewUrl} alt={it.file.name} style={styles.thumb} />
            ) : (
              <div style={styles.thumb}>{it.file.name.split(".").pop()?.toUpperCase() || "FILE"}</div>
            )}

            <div style={{ minWidth: 0 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <div style={{ fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                  {it.file.name}
                </div>
                <span style={styles.chip}>{bytesToSize(it.file.size)}</span>
                {it.uploaded && <span style={{ ...styles.chip, background: "#dcfce7" }}>Uploaded</span>}
              </div>
              {it.error ? (
                <div style={styles.error}>{it.error}</div>
              ) : (
                <div style={{ color: "#6b7280", fontSize: 12 }}>{it.file.type || "Unknown type"}</div>
              )}
              {(it.progress > 0 || it.uploaded) && (
                <div style={styles.progressBarWrap}>
                  <div style={styles.progressBar(it.progress)} />
                </div>
              )}
            </div>

            <button aria-label={`Remove ${it.file.name}`} style={styles.removeBtn} onClick={() => removeItem(it.id)}>
              ✕
            </button>
          </div>
        ))}
      </div>

      <div style={styles.actions}>
          <Button onClick={saveAudio} style={items?.length > 0 && !items?.[0]?.error ? styles.doneButtonStyle : styles.disdoneButtonStyle} startIcon={<CloudUploadIcon />} disabled={items?.length > 0 && !items?.[0]?.error ? false : true}>
                        Upload
                      </Button>
      </div>
    </div>
  );
}
// ---- Demo wrapper (you can remove this in your app) ----
export default function DragAndDropUploaderDemo({passKey,encryptpassword,setgenFileName,setmp3uplBlob,setloading}) {
  const [accepted, setAccepted] = useState([]);
  return (
    <div>
    
      <FileDropzone
       accept=" audio/*,
    .mp3,
    .wav,
    .ogg,
    .flac,
    .aac,
    .m4a,
    .wma,
    .aiff,
    .webm,
    .alac"
        multiple={false}
        // maxSize={10 * 1024 * 1024} // 10MB per file
        // uploadUrl={undefined} // set to e.g. "/api/upload" to enable uploads
        headers={{}}
        onFilesChange={(files) => setAccepted(files)}
        passKey={passKey}
        encryptpassword={encryptpassword}
        setgenFileName={setgenFileName}
        setmp3uplBlob={setmp3uplBlob}
        setloading={setloading}
      />
    <div>
      
    </div>
    </div>
  );
}
